import axiosInstance from "@/axiosConfig";
import { getApiUrl } from "@/shared/utils/api";
import { SUGGESTIONS_ENDPOINTS } from "../configs/endpoints";
import type {
  CreateUserSuggestionPayload,
  SuggestionsListResult,
  SuggestionsQueryParams,
  UpdateUserSuggestionPayload,
} from "../types/suggestions.types";

export class SuggestionsService {
  static async listSuggestions(
    params?: SuggestionsQueryParams,
  ): Promise<SuggestionsListResult> {
    const response = await axiosInstance.get<SuggestionsListResult>(
      getApiUrl(SUGGESTIONS_ENDPOINTS.LIST_SUGGESTIONS),
      { params },
    );
    return response.data;
  }

  static async createSuggestion(
    payload: CreateUserSuggestionPayload,
  ) {
    const response =
      await axiosInstance.post(
        getApiUrl(SUGGESTIONS_ENDPOINTS.CREATE_SUGGESTION),
        { user_suggestion: payload },
      );
    return response.data;
  }

  static async updateSuggestion(
    id: string,
    payload: UpdateUserSuggestionPayload,
  ) {
    const response =
      await axiosInstance.patch(
        getApiUrl(SUGGESTIONS_ENDPOINTS.UPDATE_SUGGESTION(id)),
        { user_suggestion: payload },
      );
    return response.data;
  }
}
